import * as Yup from 'yup';

export const getCashboxSchema = (isEdit) => {
  const schema = {
    name: Yup.string()
      .required("Назва рахунку обов'язкова")
      .min(2, 'Мінімум 2 символи')
      .max(50, 'Не більше 50 символів')
      .trim(),

    initialBalance: Yup.string().test('is-valid-number', 'Невірний формат суми', function (value) {
      if (!value || value === '') return true;
      const num = parseFloat(value);
      return !isNaN(num) && num >= 0;
    }),

    method: isEdit
      ? Yup.object()
          .shape({
            id: Yup.number(),
            label: Yup.string()
              .trim()
              .required("Коротка форма назви обов'язкова")
              .min(2, 'Мінімум 2 символи')
              .max(30, 'Не більше 30 символів'),
          })
          .required("Обов'язкове поле")
      : Yup.string().trim().required("Обов'язкове поле"),
  };

  return Yup.object().shape(schema);
};
